import { Toast } from "@douyinfe/semi-ui";
import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import baseUrl from "./config/config.ts";

/**
 * 封装的消息提示框
 * @param msg 提示信息
 * @param type 类型
 */
const message = (msg?: string) => {
  Toast.error({
    content: msg || "请求失败，请重试",
    duration: 3,
    showClose: false,
  });
};
/**
 * 错误统一处理
 * @param status 状态
 * @param other 其他
 */
const errorHandle = (status: number, msg?: string) => {
  // 状态码判断
  switch (status) {
    case 403:
      message("抱歉，您没有权限访问该资源");
      break;
    case 404:
      message("抱歉，资源不存在");
      break;
    case 500:
      message(msg || "抱歉，服务器出错了");
      break;
    default:
      message(msg);
  }
};

// 生成axios实例
const axiosIns: AxiosInstance = axios.create({
  baseURL: baseUrl,
  timeout: 30000, //30s超时
  withCredentials: false,
  responseType: "json",
  validateStatus() {
    // 使用async-await，处理reject情况较为繁琐，所以全部返回resolve，在业务代码中处理异常
    return true;
  },
});

//axios请求拦截
axiosIns.interceptors.request.use(
  async (config: any) => {
    // 默认设置配置
    const newConfig: any = Object.assign(
      {},
      {
        extra: {
          showMsg: true,
          allData: false,
        },
      },
      config
    );
    return newConfig;
  },
  async (error: AxiosError) => {
    return Promise.reject(error);
  }
);

//axios响应拦截
axiosIns.interceptors.response.use(
  (response: AxiosResponse) => {
    // 默认处理相同请求
    const config = response.config as any;
    const { status, data } = response;
    if (status === 200) {
      if (data.code === 0) {
        return Promise.resolve(config.extra?.allData ? data : data);
      } else {
        if (config.extra?.showMsg) {
          errorHandle(data.code, data.message);
        }
        return Promise.reject(data);
      }
    } else {
      if (config.extra?.showMsg) {
        errorHandle(response.status, data.message);
      }
      return Promise.reject(data);
    }
  },
  (error: any) => {
    // 相同请求，被取消，进入此判断
    if (axios.isCancel(error)) {
      // 直接返回错误
      return Promise.reject();
    } else {
      //请求出错的验证
      const response: any = error.response;
      if (response) {
        // 请求已发出，但是不在2xx的范围
        errorHandle(response.status, response?.data?.message);
        return Promise.reject(response);
      } else {
        // 处理额外的情况
        // eg:请求超时或断网时，更新state的network状态
        errorHandle(500, error.message);
        return Promise.reject(error);
      }
    }
  }
);

// 导出axios实例方法
export const request = <T = any>(options: any): Promise<T> => {
  return axiosIns.request<T, T>(options);
};

export default axiosIns;
